// removed by extract-text-webpack-plugin
module.exports = {"block":"_3uSm0hukCpgrfl--zTmXEw","heading":"KlA51ptJHOmrf8QHiBNPh","lightGrey":"_2pzmRQQHuHcjjrsJr9i4kJ","yellow":"_1QzEexmjP_sv6Bo60142lo","blue":"_24jUFTbZV7AyQmJyBqsVmL","items":"_10C5zH0rJ6cdAT-Dk-nnfI","item":"_2JiLx8eb6RTpdG0kdd9WnH","link":"_137va5i2HY614P9nzYUjbJ","active":"_1_9HcUyAjP6BxgmgdsV7I2","linkText":"_26xD18bRDvhKqDeqHGA-UN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TopicAreasNavigationBlock/TopicAreasNavigationBlock.module.scss
// module id = 812
// module chunks = 0